import { SVGProps } from 'react';

interface CopyIconProps extends SVGProps<SVGSVGElement> {
	strokeColor?: string; // Nueva prop para personalizar el color del trazo
}

export const CopyIcon = ({ strokeColor = '#646174', ...props }: CopyIconProps) => (
	<svg
		width="24"
		height="25"
		viewBox="0 0 24 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M9 8.23535C9 7.68307 9.44772 7.23535 10 7.23535H15C15.5523 7.23535 16 7.68307 16 8.23535V9.73535C16 10.2876 16.4477 10.7354 17 10.7354H19C19.5523 10.7354 20 11.1831 20 11.7354V19.2354C20 19.7876 19.5523 20.2354 19 20.2354H10C9.44771 20.2354 9 19.7876 9 19.2354V8.23535Z"
			stroke={strokeColor}
			strokeWidth="1.5"
		/>
		<path
			d="M14 5.23535V4.23535C14 3.68307 13.5523 3.23535 13 3.23535H5C4.44772 3.23535 4 3.68307 4 4.23535V14.2354C4 14.7876 4.44772 15.2354 5 15.2354H7"
			stroke={strokeColor}
			strokeWidth="1.5"
		/>
		<path d="M11.3047 13.7354H14.0436" stroke={strokeColor} strokeWidth="1.5" />
		<path d="M11.3047 10.7354H14.0436" stroke={strokeColor} strokeWidth="1.5" />
		<path d="M11.3047 16.7354H17.6955" stroke={strokeColor} strokeWidth="1.5" />
	</svg>
);
